// extracted by mini-css-extract-plugin
export default {"view-btn":"ViewReceiptDrawer_view-btn__c5DLx"};